import { PrismicImage, PrismicLink, PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.ArticleLinkedContentSlice} ArticleLinkedContentSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ArticleLinkedContentSlice>} ArticleLinkedContentProps
 * @param {ArticleLinkedContentProps}
 */
const ArticleLinkedContent = ({ slice, index }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="border-t-2 border-dark-grey py-10 md:py-20 bg-grain">
      <div className="px-4 md:px-7 lg:px-10 max-w-[1300px] m-auto">
        <div className="mb-30px md:mb-14 md:text-center">
          <PrismicRichText field={slice.primary.title} />
        </div>
        <div className="md:flex md:flex-wrap justify-between lg:flex-nowrap md:gap-10 xl:gap-x-[70px]">
          {
            slice.primary.articles.map(({ article }, i) =>
              <div
                key={i}
                className="mb-12 md:mb-0 md:basis-[47%] md:last:basis-full lg:basis-1/3 lg:last:basis-1/3  bg-white border-2 rounded-b-[30px] rounded-tl-[92px] border-dark-grey ">
                <PrismicLink field={article}>
                  <div>
                    <PrismicImage field={article.data.preview_picture}  loading={index === 0 ? '' : 'lazy'}
                      className="rounded-tl-[90px] border-b-2 border-dark-grey w-full h-[200px] object-cover" />
                  </div>
                  <div className="px-30px py-6 md:pt-30px md:pb-10">
                    <div className="bg-dark-pink w-fit px-4 border-2 border-dark-grey rounded-full mb-4">
                      <p className="filtre-text font-semibold"> {article.data.preview_tag}</p>
                    </div>
                    <PrismicRichText field={article.data.preview_title} components={{ heading3: ({ children }) => <h3 className="mb-2.5">{children}</h3> }} />
                    <PrismicRichText field={article.data.preview_text} components={{ paragraph: ({ children }) => <p className="line-clamp-4">{children}</p> }} />
                  </div>
                </PrismicLink>
              </div>
            )}
        </div>
      </div>
    </section >
  );
};

export default ArticleLinkedContent;
